import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import { ToastMessage } from '@bibliocommons/shared-messages';
import { messagingShape } from '@bibliocommons/bc-prop-types';
import MessagingActions from 'app/actions/MessagingActions';
import { getGlobalMessaging } from 'app/selectors/MessagingSelector';

import './GlobalMessagingContainer.scss';

function GlobalMessagingContainer({ messaging, messagingActions }) {
  return (
    <TransitionGroup>
      {messaging && (
        <CSSTransition
          classNames="global-messaging-slide-up"
          timeout={{ enter: 250, exit: 100 }}
          key="global-messaging"
          mountOnEnter
          unmountOnExit
        >
          <ToastMessage
            message={messaging.get('message')}
            fieldErrors={messaging.get('fieldErrors')}
            duration={messaging.get('duration')}
            failureDuration={messaging.get('failureDuration')}
            values={messaging.get('values')}
            useFormattedMessage={messaging.get('useFormattedMessage')}
            clearMessages={() => messagingActions.clearGlobalMessage()}
            renderActionsButton={messaging.get('renderActionsButton')}
          />
        </CSSTransition>
      )}
    </TransitionGroup>
  );
}

GlobalMessagingContainer.propTypes = {
  messaging: messagingShape,
  messagingActions: PropTypes.objectOf(PropTypes.func).isRequired
};

const mapStateToProps = state => ({
  messaging: getGlobalMessaging(state)
});

const mapDispatchToProps = dispatch => ({
  messagingActions: bindActionCreators(MessagingActions, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GlobalMessagingContainer);
